// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3NZht","vLegacy":"SelectSecondary_vLegacy__2MuOi","error":"SelectSecondary_error__3mInv","disabled":"SelectSecondary_disabled__Q_xi5"};